import { render, staticRenderFns } from "./CorpRegionRanking.vue?vue&type=template&id=123f3477&scoped=true&"
import script from "./CorpRegionRanking.vue?vue&type=script&lang=js&"
export * from "./CorpRegionRanking.vue?vue&type=script&lang=js&"
import style0 from "./CorpRegionRanking.vue?vue&type=style&index=0&id=123f3477&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123f3477",
  null
  
)

export default component.exports